import { createBednbodyClient } from "@bednbody/supabase";
import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@bednbody/types";

// Staff auth is email + password + enforced MFA (vault ARCHITECTURE.md §Auth flow).
// No storage adapter override needed here — admin never ships to Capacitor
// (REPO.md §3), so the factory default (localStorage) is correct.
const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    "Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY — check Doppler → Vercel env sync for bednbody-admin.",
  );
}

// Narrowed copies for use inside functions — TS control-flow narrowing from
// the guard above doesn't reach into function bodies defined later.
const SUPABASE_URL: string = url;
const SUPABASE_ANON_KEY: string = anonKey;

export const supabase: SupabaseClient<Database> = createBednbodyClient(url, anonKey);

/**
 * Ephemeral client for auth-bootstrap flows (roster "Add Employee"). GoTrue
 * signUp signs the NEW user in on whatever client runs it, so it must never
 * share storage with the admin's own session — no persistence, no refresh.
 * No service_role here (security.md): the auth account itself grants nothing;
 * the privilege is the RLS-gated `staff` row (staff_admin_write, 0003).
 */
export function createAuthBootstrapClient() {
  return createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
    auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false },
  });
}
